<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">
                    Draggable Video List
                </div>
                <router-link class="btn btn-primary waves-effect pull-right" title='Add Video' v-bind:to="{name: 'AddMedia', params:{slug:'video'}}">Add Video</router-link>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="cards-container">
                    <draggable v-model="imageList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(text, index) in imageList">
                            <div class="col-4 mb-5">
                                <div class="cards-block">
                                    <div class="card">
                                        <template v-if="text.type == 'url'">
                                            <img class="card-img-top" :src="'/static/images/video.jpg'" :key="index">
                                        </template>
                                        <template v-if="text.type == 'video'">
                                            <img class="card-img-top" :src="text.image" :key="index" >
                                        </template>
                                        <div class="card-body">
                                            <button class="ml-2 mr-2 btn btn-danger pull-right"  v-on:click.prevent="deleteVideo(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                            <router-link class="ml-2 mr-2 btn btn-success pull-right" v-bind:to="{name: 'PlayVideos',params:{id:text.id}}"><i class="fa fa-eye" aria-hidden="true"></i></router-link>
                                            <template v-if="text.show_at_home == 0">
                                                <button class=" btn btn-success pull-right" v-on:click.prevent="showHideFromHome(text.id)">Show at Home</button>
                                            </template>
                                            <template v-else>
                                                <button class=" btn btn-danger pull-right" v-on:click.prevent="showHideFromHome(text.id)">Hide from Home</button>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>
<script>
    import $ from 'jquery';
    import BackendFooter from '@/components/backend/partials/Footer';
    import draggable from 'vuedraggable';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Videos',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                imageList: [],
                imagePosition: [],
                videoId: '',
            }
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.MenuClose();
            self.getVideos();
        },
        methods: {
            showHideFromHome: function (id) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    id: id,
                };
                HTTP.post("hidefromhome", fields, config)
                    .then(function (response) {
                        self.getVideos();
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });

            },
            deleteVideo: function (id) {
                //console.log(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletemedia", config)
                                .then(function (response) {
                                    self.getVideos();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal({
                            title: 'Deleted',
                            type: 'success',
                            text: 'You successfully deleted the record(s).',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                        //self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            text: 'Your record(s) still intact',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            getVideos() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                /*var fields = {
                 limit: 2,
                 };*/
                self.showLoader();
                HTTP.get("listvideos", config)
                        .then(function (response) {
                            self.imageList = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changePosition() {
                var fields = {
                    imageList: self.imageList,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    imageList: self.imageList,
                };
                HTTP.post("changeposition", fields, config)
                        .then(function (response) {

                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>
<style>

    /*
    * {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        font-family: Arial, Helvetica, sans-serif;
    }

    .header {
        text-align: center;
        padding: 32px;
    }

    .row {
        display: -ms-flexbox; 
        display: flex;
        -ms-flex-wrap: wrap; 
        flex-wrap: wrap;
        padding: 0 4px;
    }

    
    .column {
        -ms-flex: 50%;
        flex: 50%;
        padding: 0 4px;
    }

    .column img {
        margin-top: 8px;
        vertical-align: middle;
    }

    .btn {
        border: none;
        outline: none;
        padding: 10px 16px;
        background-color: #f1f1f1;
        cursor: pointer;
        font-size: 18px;
    }

    .btn:hover {
        background-color: #ddd;
    }

    .btn.active {
        background-color: #666;
        color: white;
    }
    */
</style>


// WEBPACK FOOTER //
// src/components/backend/gallery/ListVideos.vue